/*
 * Copyright (c) 2023 by N-Ach (Pvt) Ltd
 *
 * ╔═╗ ╔╗    ╔═══╗  ╔╗
 * ║║╚╗║║    ║╔═╗║  ║║
 * ║╔╗╚╝║    ║║ ║╠══╣╚═╗
 * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║
 * ║║ ║║║╚══╝║╔═╗║╚═╣║║║
 * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information
 * of N-Ach (Pvt) Ltd. You shall not disclose such Confidential
 * Information and shall use it only in accordance with the terms
 * of the license agreement you entered into with N-Ach (Pvt) Ltd.
 *
 *
 * @Author Dilhari Jayathunga
 * @Date 16/11/2023
 */

import { Backdrop, CircularProgress, Grid, OutlinedInput, Paper, Rating, Typography } from '@mui/material'
import React, { useContext } from 'react'
import styles from "./AdditionalDetailsStep.module.css"
import { isMobile } from 'react-device-detect'
import CheckoutContext from '../../Context/CheckoutContext'
import { SET_COMMENTS, SET_HOURS, SET_MATERIALS_NEEDED, SET_NO_OF_PROFESSIONALS } from '../../Pages/CheckoutPage'
import Summary from './Summary'
import { useGetAllNoOfHoursQuery } from '../../Store/Services/TimeService'
import { useGetAllNoOfResourcesQuery } from '../../Store/Services/ResourceService'
import NoHrsSelect from './NoHrsSelect'
import NoResSelect from './NoResSelect'
import { useEffect } from 'react'
import ReqImageUploader from './ReqImageUploader'

const AdditionalDetailsStep = ({categories, setIsDisabled}) => {

    const { checkoutData, dispatch } = useContext(CheckoutContext);

    const onMaterialChange = (data) => {
        dispatch({ type: SET_MATERIALS_NEEDED, payload: data})
    }

    const onAddComment = (e) => {
        dispatch({ type: SET_COMMENTS, payload: e.target.value})
    }

    useEffect(() => {
        const UpdateDisabled = () => {
            if(checkoutData.amount!==0) {
                setIsDisabled(false)
            } else {
                setIsDisabled(true)
            }
        }
        UpdateDisabled()
    }, [checkoutData])

    const selectedCatDetails = categories?.filter(cat => cat.catId === checkoutData.catId)[0]
    useEffect(() => {
       
    }, [categories]);
    return (
        <div className={styles.container}>
            <Grid container spacing={3}>
                <Grid item xs={12} md={7}>
                    <Paper className={styles.paper} elevation={isMobile? 0: 3}>
                        <Typography className={styles.topic}>Service Details</Typography>
                        <div className={styles.inputContainer}>
                            <Typography className={styles.subTitle}>How many hours do you need your professional to stay?</Typography>
                            <NoHrsSelect noHrs={selectedCatDetails?.noHrsList} />
                        </div>
                        <div className={styles.inputContainer}>
                            <Typography className={styles.subTitle}>How many professionals do you need?</Typography>
                            <NoResSelect noRes={selectedCatDetails?.noResList} />
                        </div>
                        <div className={styles.inputContainer}>
                            <Typography className={styles.subTitle}>Need cleaning materials?</Typography>
                            <div className={styles.selectionContainer}>
                                <div
                                    onClick={() => onMaterialChange(1)}
                                    className={`${styles.option} ${checkoutData.isMaterialsNeeded == 1 && styles.numberButtonSelected}`}
                                >
                                    Yes
                                </div>
                                <div
                                    onClick={() => onMaterialChange(0)}
                                    className={`${styles.option} ${checkoutData.isMaterialsNeeded == 0 && styles.numberButtonSelected}`}
                                >
                                    No
                                </div>
                            </div>
                        </div>
                        <div className={styles.textInputContainer}>
                            <Typography className={styles.textSubTitle}>Any instructions or special requirements?</Typography>
                            <OutlinedInput className={styles.textInput} onChange={onAddComment} multiline rows={4} fullWidth size='small' color='primary'/>
                        </div>
                        <div className={styles.textInputContainer}>
                            <Typography className={styles.textSubTitle}>Please upload any images of the requirement.</Typography>
                            <ReqImageUploader />
                        </div>
                    </Paper>
                </Grid>
                <Grid item xs={12} md={5}>
                    <Summary />
                </Grid>
            </Grid>
        </div>
    )
}

export default AdditionalDetailsStep